import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import InputForm from '../../../../../components/form/InputForm';
import SelectForm from '../../../../../components/form/SelectForm';
import BaseForm from '../../../../../components/form/BaseForm';
import ImgUpload from '../../../../../components/ImgUpload';
import { REX_BUSINESS_LICENSE, REX_NAME, REX_ONLINE_SALES_REG } from '../../../../../lib/rex';
import { ACCOUNT_SELLER_BUSINESS_TYPE_SELECT_LIST } from '../../../../../constants/service/app/accountSellerConstants';
import {
  MAXIMUM_NUMBER_OF_STORE_ATTACHMENT,
  MAXIMUM_NUMBER_OF_COMPANY_NAME,
  BRAND_DETAIL_PAGE_PANEL_NAME,
} from '../../../../../constants/service/app/brandConstants';
import { formRequiredRules } from '../../../../../lib/formRules';
import { setBusinessNumberFormat } from '../../../../../lib/common';
import './BrandDetailInfoBusiness.scss';

const BrandDetailInfoBusiness = (props) => {
  const { data, setData, form, isEditable } = props;
  const {
    businessType,
    companyName,
    ceoName,
    businessLicenseNumber,
    businessLicenseImg,
    onlineSalesRegNumber,
    onlineSalesRegImg,
  } = data;

  return (
    <Panel name={BRAND_DETAIL_PAGE_PANEL_NAME.BUSINESS} className="brand-detail-info-business">
      <div className="panel-header">
        <div className="title">사업자 정보</div>
      </div>

      <div className="panel-body">
        <div className="type-name-wrap">
          {/* 사업 유형 */}
          <SelectForm
            label="사업 유형"
            form={form}
            isEditable={isEditable}
            initialValue={businessType}
            list={ACCOUNT_SELLER_BUSINESS_TYPE_SELECT_LIST}
            onChange={(value) => setData({ path: ['brandDetail', 'info', 'businessInfo', 'businessType'], value })}
            name="businessType"
          />

          {/* 상호/법인명 */}
          <InputForm
            label="상호/법인명"
            form={form}
            isEditable={isEditable}
            rules={[formRequiredRules(true, '필수사항 입니다.')]}
            initialValue={companyName}
            onChange={(value) =>
              setData({
                path: ['brandDetail', 'info', 'businessInfo', 'companyName'],
                value,
              })
            }
            maxLength={MAXIMUM_NUMBER_OF_COMPANY_NAME}
            name="companyName"
          />

          {/* 대표자 명 */}
          <InputForm
            label="대표자 명"
            form={form}
            isEditable={isEditable}
            rules={[
              formRequiredRules(true, '필수사항 입니다.'),
              { pattern: REX_NAME, message: '이름을 확인해주세요!' },
            ]}
            initialValue={ceoName}
            onChange={(value) =>
              setData({
                path: ['brandDetail', 'info', 'businessInfo', 'ceoName'],
                value,
              })
            }
            name="ceoName"
          />
        </div>

        <div className="businessLicense-wrap">
          {/*사업자등록번호 이미지*/}
          <BaseForm
            label="사업자 등록번호 이미지"
            content={
              <ImgUpload
                list={businessLicenseImg}
                modalTitle="사업자등록번호 이미지"
                minCnt={MAXIMUM_NUMBER_OF_STORE_ATTACHMENT}
                setData={setData}
                targetPath={['brandDetail', 'info', 'businessInfo', 'businessLicenseImg']}
                name="businessImg"
                isEditable={isEditable}
                cropMode={false}
              />
            }
          />

          {/* 사업자 등록번호 */}
          <InputForm
            label="사업자 등록번호"
            form={form}
            isEditable={isEditable}
            rules={[
              formRequiredRules(true, '필수사항 입니다.'),
              { pattern: REX_BUSINESS_LICENSE, message: '사업자 등록번호의 형식이 올바르지 않습니다.' },
            ]}
            initialValue={setBusinessNumberFormat(businessLicenseNumber)}
            getValueFromEvent={(value) => setBusinessNumberFormat(value)}
            onChange={(value) =>
              setData({
                path: ['brandDetail', 'info', 'businessInfo', 'businessLicenseNumber'],
                value,
              })
            }
            name="businessLicenseNumber"
          />
        </div>

        <div className="onlineSalesReg-wrap">
          {/*통신판매업 신고 이미지*/}
          <BaseForm
            label="통신판매업 신고 이미지"
            content={
              <ImgUpload
                list={onlineSalesRegImg}
                modalTitle="통신판매업 신고 이미지"
                minCnt={MAXIMUM_NUMBER_OF_STORE_ATTACHMENT}
                setData={setData}
                targetPath={['brandDetail', 'info', 'businessInfo', 'onlineSalesRegImg']}
                name="onlineSalesRegImg"
                isEditable={isEditable}
                cropMode={false}
              />
            }
          />

          {/* 통신판매업 신고 */}
          <InputForm
            label="통신판매업 신고"
            form={form}
            isEditable={isEditable}
            rules={[
              formRequiredRules(true, '필수사항 입니다.'),
              { pattern: REX_ONLINE_SALES_REG, message: '통신판매 신고번호의 형식이 잘못되었습니다.' },
            ]}
            initialValue={onlineSalesRegNumber}
            onChange={(value) =>
              setData({
                path: ['brandDetail', 'info', 'businessInfo', 'onlineSalesRegNumber'],
                value,
              })
            }
            name="onlineSalesRegNumber"
          />
        </div>
      </div>
    </Panel>
  );
};

export default BrandDetailInfoBusiness;
